import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { ProgressBar, Offcanvas, Container, Row, Card } from "react-bootstrap";
import "../common/CustomModal.css";
import { variables } from "../../Variables.json";
import api from "../../seller-apis/api";
import axios from "axios";
import convertFileToWebP from "../../utilities/convertFileToWebP";
import { GenUtilities } from "../../utilities/GenUtilities";

const ImageModalUpload = ({ show, handleClose, handleConfirm, product }) => {
  const [video, setVideo] = useState("");
  const [progress, setProgress] = useState();
  const [urlList, seturlList] = useState([]);
  const [image1, setimage1] = useState("");
  const [image2, setimage2] = useState("");
  const [image3, setimage3] = useState("");
  const [error, seterror] = useState(false);
  const [imagecov, setimagecov] = useState("");
  const [urlListshow, seturlListshow] = useState(false);
  const [imgprogress, setimgprogress] = useState();
  const [imgLabelDisable, setimgLabelDisable] = useState(false);
  const [images, setImages] = useState([]);
useEffect(()=>{
  setimage1("");
  setimage2("");
  setimage3("");
  setimagecov("");
  setImages([]);
},[product])
  const alert = useAlert();
  var imagesName = [];
  var imgUrls = [];
  var s3Urls = [];
  async function showImage(event, spcl) {
    console.log('dfs')
    seterror(false);
    let comImg;
    let imageFinal;
    let registerImage;
    let isimgsSizevalid = true;
    let limit = event.target.files.length;
    // for (let i = 0; i < limit; i++) {
    //   if (event.target.files[i].size > variables.limit.Newproductupload.image) {
    //     isimgsSizevalid = false;
    //   }
    // }
    // if (isimgsSizevalid) {
      setimgLabelDisable(true);
      seturlListshow(false);
      for (let i = 0; i < limit; i++) {
        let convertedImg= await convertFileToWebP(event.target.files[i]);
        var str = convertedImg.name;
        let extension = convertedImg.name.slice(
          convertedImg.name.lastIndexOf(".")
          );
        comImg = str.replace(/[^\w]/g, "");
        let vendorId = product.vendor?._id;
        imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + comImg + extension);
        registerImage = convertedImg;
        if (spcl === "cov") {
          imagesName.unshift(imageFinal);
        } else {
          imagesName.push(imageFinal);
        }
        setImages(prevVal => [...prevVal, ...imagesName]);
        switch (spcl) {
          case "cov":
            setimagecov(imageFinal);
            break;
          case "1":
            setimage1(imageFinal);
            break;
          case "2":
            setimage2(imageFinal);
            break;
          case "3":
            setimage3(imageFinal);
            break;
        }
        var data = {
          imageName: imageFinal,
          type: "products",
        };
        api.product
          .saveProductImage(data)
          .then((res) => {
            axios({
              method: "put",
              url: res.data,
              data: registerImage,
              onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                setimgprogress(Math.round((100 * data.loaded) / data.total));
              },
            })
              .then((response) => {
                setimgprogress();
                setimgLabelDisable(false);
                seturlList(imagesName);
                seturlListshow(true);
              })
              .then((response) => {
                setimgprogress();
                setimgLabelDisable(false);
                seturlList(imagesName);
                seturlListshow(true);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => console.log(err));
        s3Urls.push(imageFinal);
      }
    // } else {
    //   alert.info("Please upload image of size less than or equal to 500 kb");
    // }
  }
  function deleteImg(spcl, ele) {
    // seturlListshow(false)
    seturlList([]);
    images.splice(spcl, 1);
    setImages([...images]);
    switch (spcl) {
      case 0:
        setimagecov("");
        break;
      case 1:
        setimage1("");
        break;
      case 2:
        setimage2("");
        break;
      case 3:
        setimage3("");
        break;
    }
    let eleLoader = document.getElementById(ele);
    seturlList(imagesName);
    eleLoader.setAttribute("class", "spinner-border text-info");
  }
  const addProduct = () => {
    if (imagecov === undefined || imagecov === "") {
      // alert.info("Please upload cover image.");
      seterror(true);
    } else {
      for (let i = 0; i < images.length; i++) {
        if (i === 0) {
          let data = {
            baseImage: true,
            smallImage: false,
            thumbnail: false,
            visible: false,
            image: "products/" + images[i],
            label: images[i],
          };
          imgUrls.push(data);
        } else {
          let data = {
            baseImage: false,
            smallImage: false,
            thumbnail: false,
            visible: false,
            image: "products/" + images[i],
            label: images[i],
          };
          imgUrls.push(data);
        }
      }
      product["images"] = imgUrls;
      console.log(product)
      api.product
        .addNewProduct(product)
        .then((res) => {
          alert.success("Image(s) added successfully");
          handleClose();
          // if (NewVendTotalprcount === 0) {
          //   NewVendTotalprcount = NewVendTotalprcount + 1;
          //   pkgData.product = res._id;
          //   window.location.assign("/regprosuccess");
          // } else {
          //   window.location.assign("/my-inventory/new_product_request/manual");
          // }
        })
        .catch((err) => {
          console.log(err);
          alert.error("Failed to add video");
        });
    }
  };
  return (
    <Modal
      className="custom-modal"
      size="lg"
      centered
      show={show}
      onHide={handleClose}
    >
      <Modal.Body>
        <div className="row d-flex justify-content-center">
          {/* <div className="col-10 d-flex"> */}
          {imgprogress && (
            <ProgressBar
              id="progress-B"
              className="add_pro_form_progressbar"
              now={imgprogress}
              label={`${imgprogress}%`}
            />
          )}
          {!imagecov && error && 
          <p className="text-center error mb-2">Please upload cover image.</p>
          }
          <div className="col-4  add_pro_form_image_box">
            <div className="add_pro_form_image_cntn vid-P">
              <label
                for={"imgUploadCov"}
                id="uploadIcon"
                className="add_pro_form_label"
              >
                {/* <i
                      className="fa fa-plus-circle add_pro_form_i_nm"
                      aria-hidden="true"
                    ></i> */}
                <img src="/ImageAdd.png" alt="Add image" />
              </label>
              {urlListshow === true &&
              imagecov !== undefined &&
              imagecov !== "" ? (
                <>
                  <img
                    src={
                      "https://s3.toolsvilla.com/products/" +
                      imagecov
                    }
                    className="add_pro_form_image_file vid-P"
                    alt="img"
                    id="contain-Img-Pro-Cov"
                  />
                  {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                  <i
                    className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                    onClick={() => deleteImg(0, "contain-Img-Pro-Cov")}
                  ></i>
                </>
              ) : (
                <></>
              )}
            </div>
            <label>*Cover photo</label>
            <input
              type="file"
              id="imgUploadCov"
              className="add_pro_form_uploadFile"
              onChange={(event) => showImage(event, "cov")}
              onClick={(e) => (e.target.value = null)}
              accept="image/*"
            />
          </div>

          {/* 1 image */}
          <div className="col-4 add_pro_form_image_box">
            <div className="add_pro_form_image_cntn">
              <label
                for={"imgUploadImg_1"}
                id="uploadIcon"
                className="add_pro_form_label"
              >
                {/* <i
                      className="fa fa-plus-circle add_pro_form_i_nm"
                      aria-hidden="true"
                    ></i> */}
                <img src="/ImageAdd.png" alt="Add image" />
              </label>
              {urlListshow === true && image1 !== undefined && image1 !== "" ? (
                <>
                  <img
                    src={
                      "https://s3.toolsvilla.com/products/" + image1
                    }
                    className="add_pro_form_image_file vid-P"
                    alt="img"
                    id="contain-Img-Pro-1"
                  />
                  {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                  <i
                    className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                    onClick={() => deleteImg(1, "contain-Img-Pro-1")}
                  ></i>
                </>
              ) : (
                <></>
              )}
            </div>
            <label>Image 1</label>
            <input
              type="file"
              id="imgUploadImg_1"
              className="add_pro_form_uploadFile"
              onChange={(event) => showImage(event, "1")}
              onClick={(e) => (e.target.value = null)}
              accept="image/*"
            />
          </div>

          {/* 2 image */}
          <div className="col-4 add_pro_form_image_box">
            <div className="add_pro_form_image_cntn">
              <label
                for={"imgUploadImg_2"}
                id="uploadIcon"
                className="add_pro_form_label"
              >
                {/* <i
                      className="fa fa-plus-circle add_pro_form_i_nm"
                      aria-hidden="true"
                    ></i> */}
                <img src="/ImageAdd.png" alt="Add image" />
              </label>
              {urlListshow === true && image2 !== undefined && image2 !== "" ? (
                <>
                  <img
                    src={
                      "https://s3.toolsvilla.com/products/" + image2
                    }
                    className="add_pro_form_image_file vid-P"
                    alt="img"
                    id="contain-Img-Pro-2"
                  />
                  {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                  <i
                    className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                    onClick={() => deleteImg(2, "contain-Img-Pro-2")}
                  ></i>
                </>
              ) : (
                <></>
              )}
            </div>
            <label>Image 2</label>
            <input
              type="file"
              id="imgUploadImg_2"
              className="add_pro_form_uploadFile"
              onChange={(event) => showImage(event, "2")}
              onClick={(e) => (e.target.value = null)}
              accept="image/*"
            />
          </div>

          {/* 3 image */}
          <div className="col-4 add_pro_form_image_box">
            <div className="add_pro_form_image_cntn">
              <label
                for={"imgUploadImg_3"}
                id="uploadIcon"
                className="add_pro_form_label"
              >
                {/* <i
                      className="fa fa-plus-circle add_pro_form_i_nm"
                      aria-hidden="true"
                    ></i> */}
                <img src="/ImageAdd.png" alt="Add image" />
              </label>
              {urlListshow === true && image3 !== undefined && image3 !== "" ? (
                <>
                  <img
                    src={
                      "https://s3.toolsvilla.com/products/" + image3
                    }
                    className="add_pro_form_image_file vid-P"
                    alt="img"
                    id="contain-Img-Pro-3"
                  />
                  {/* <i className="bi bi-x-square-fill fs-14 text-yellow add_pro_form_med_del_btn_img" onClick={() => deletevideo(index)}></i> */}
                  <i
                    className="bi bi-trash fs-14 add_pro_form_med_del_btn_img"
                    onClick={() => deleteImg(3, "contain-Img-Pro-3")}
                  ></i>
                </>
              ) : (
                <></>
              )}
            </div>
            <label>Image 3</label>
            <input
              type="file"
              id="imgUploadImg_3"
              className="add_pro_form_uploadFile"
              onChange={(event) => showImage(event, "3")}
              onClick={(e) => (e.target.value = null)}
              accept="image/*"
            />
          </div>
          {/* </div> */}
        </div>

        <div className="action-buttons">
          <Button
            className="yes-button"
            variant="secondary flex-center"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => addProduct()}
            className="no-button flex-center"
          >
            Add Images
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ImageModalUpload;
